
    import { mdiExport } from '@mdi/js';
    import { saveAs } from 'file-saver';
    import {
        Component, Prop, Ref, Vue,
    } from 'vue-property-decorator';
    import {
        VBtn,
        VDialog,
        VDivider,
        VCard,
        VCardActions,
        VCardText,
        VCardTitle,
        VIcon,
        VSpacer,
    } from 'vuetify/lib';
    import Converter from '@/tunings/converter';
    import { TuningRaw, TuningSchema } from '@/tunings/types';

    @Component({
        components: {
            VBtn,
            VDialog,
            VDivider,
            VCard,
            VCardActions,
            VCardText,
            VCardTitle,
            VIcon,
            VSpacer,
        },
        filters: {
            pretty(value: string) {
                return JSON.stringify(value, null, 2);
            },
        },
    })
    export default class Export extends Vue {
        @Prop({ required: true })
        schema!: TuningSchema;

        @Ref()
        readonly copyContainer!: any;

        exportDialog = false;

        iconMdiExport = mdiExport;

        generatedTuning: TuningRaw = {};

        get canExport(): boolean {
            return Object.keys(this.generatedTuning).length > 0;
        }

        copy() {
            // @ts-ignore
            this.$copyText(JSON.stringify(this.generatedTuning), this.copyContainer.$el)
                .then(() => {
                    this.snack('success', 'Copied to clipboard');
                }, () => {
                    this.snack('error', 'Unable to copy to clipboard');
                });
        }

        generateTuning() {
            this.generatedTuning = Converter.get(this.schema, { stripDefaults: true });

            if (Object.keys(this.generatedTuning).length > 0) {
                this.generatedTuning.tuningMessage = `Tuning generated at ${window.location}`;
            }
        }

        saveAs() {
            saveAs(new Blob([JSON.stringify(this.generatedTuning)]), 'tuning.json', { type: 'application/json;charset=utf-8' });
        }

        snack(colour: string, message: string) {
            this.$emit('snack', colour, message);
        }
    }
